<template>
  <div>



      <vs-divider class="mt-10 mb-10"> Broker Information </vs-divider>
      <add-broker-component :broker-data-prop="null" />
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import AddBrokerComponent from "../../components/AddBrokerComponent";

  export default {
    name: "Add",
    components: {AddBrokerComponent},
    data() {
      return {
        hostawayID: null,
        hoteltaskRoomTypeShortCode : null,
        propertyComponentKey: 0
      }
    },
    computed: {
      ...mapGetters({
        isLoading: 'brokers/isLoading',
        error: 'brokers/error',
      })
    },
    methods: {
      ...mapActions({
        loadListingApiData: 'get',
      }),
      errorNotify(msg){
        this.$vs.notify({color:'danger',title:'Error',text:msg})
      },
    },
    watch: {
      isLoading(newValue) {
        if (newValue) {
          this.$vs.loading()
        }else {
          this.$vs.loading.close()
        }
      },
    },
  }
</script>

<style scoped>

</style>
